module.exports = __webpack_public_path__ + "static/media/stw.39bcb46b.png";